import React from 'react';
import * as _ from 'lodash';
import _masterSlideLoader from '../utilities/masterSlideLoader';
import Helmet from 'react-helmet';

import {
  HEADER_CONSTANTS, // ヘッダータイトル
  USER_ROLES,
} from '../utilities/constants';

import { CompanyBranchForm } from '../components/forms/PrimeBranch'; // フォーム
import { CompanyService } from '../services/Companies';
import { CompanyBranchService } from '../services/CompanyBranches'; // 協力会社API
import { UserProfileService } from '../services/UserProfiles';
import { BranchListDropdown } from '../components/dropdowns/single/BranchList';
import { PrimaryCompanyNaviList } from '../components/list/PrimaryCompanyNaviList';
import { isLoginUserPartner } from '../utilities/roleUtility';
import SessionStorageService from '../../src/services/utilities/SessionStorageService';
import { MasterPageHeader } from '../components/PageHeader';

export class PrimeBranchPreview extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      userId: localStorage.getItem('user_id'),
      roleId: localStorage.getItem('role_id'),
      companyId: SessionStorageService.getCompanyId(),
      branchId: this.props.view.state.id, // 支店Id
      use_greenfile_flg: '', // 労務安全使用フラグ
      formValues: {
        company_id: '',
        billing_target_id: '',
        name: '',
        kana: '',
        postal_code: '',
        prefectures_code_id: '',
        city_name: '',
        street_number: '',
        building_name: '',
        tel: '',
        fax: '',
        delegate_name: '',
        charge_name: '',
        charge_name_kana: '',
        department: '',
        job_title: '',
        email: '',
        use_partner_company_approval_default_flag: '',
        billing_flag: '',
        billing_target: {
          postal_code: '',
          prefectures_code_id: '',
          city_name: '',
          street_number: '',
          building_name: '',
          tel: '',
          fax: '',
          charge_name: '',
          charge_name_kana: '',
          department: '',
          job_title: '',
          email: '',
        },
      },
      expirationCompany: {},
    };

    this.initForm = this.initForm.bind(this); // フォーム生成
    this.getBranch = this.getBranch.bind(this); // 自社情報取得
    this.setBranch = this.setBranch.bind(this); // 支店選択
  }

  componentWillMount() {
    if (this.state.branchId > 0) {
      this.getBranch(this.state.branchId);
    } else {
      if (this.state.roleId == USER_ROLES.prime.id) {
        CompanyBranchService.companyBranchList({}).then(response => {
          if (response.result) {
            const company_branches = response.data.entities.company_branches;
            if (!_.isEmpty(company_branches)) {
              this.setBranch('', company_branches[0].id);
            }
          }
        });
      } else if (this.state.roleId == USER_ROLES.branch.id) {
        UserProfileService.show(this.state.userId).then(response => {
          let company_branch;
          if (isLoginUserPartner()) {
            const sessionPrimeCompanyId = SessionStorageService.getItem(
              'sessionPartnerCompanyIdOfPrimeCompany'
            );
            if (sessionPrimeCompanyId) {
              company_branch = _.find(
                response.data.entities.company_branch,
                companyBranch => {
                  return (
                    String(companyBranch.company_id) === sessionPrimeCompanyId
                  );
                }
              );
            }
          } else {
            company_branch = response.data.entities.company_branch[0];
          }

          if (response.result) {
            this.setBranch('', company_branch.id);
          }
        });
      }
    }
  }

  getExpiration = async () => {
    await CompanyService.expirations(this.state.companyId).then(response => {
      if (!response.result) {
        return;
      }
      this.setState({
        expirationCompany: {
          ...this.state.expirationCompany,
          ...response.data.entities.company.expiration,
        },
      });
    });
  };

  componentDidMount() {
    UserProfileService.show(this.state.userId).then(response => {
      if (response.result) {
        const entity = response.data.entities;
        this.setState({
          use_greenfile_flg: entity.use_greenfile_flg,
        });
      }
    });
    this.getExpiration();
  }

  getBranch(branchId) {
    CompanyBranchService.showBranch(branchId).then(response => {
      if (response.result) {
        this.initForm(response.data.entities);
      }
    });
  }

  /**
   * 元請選択
   * @param value {int} 会社Id
   */
  setBranch(name, value) {
    let state = this.state;
    if (value) {
      this.getBranch(value);
      state.branchId = value;
    } else {
      state.formValues = {
        company_id: '',
        billing_target_id: '',
        name: '',
        kana: '',
        postal_code: '',
        prefectures_code_id: '',
        city_name: '',
        street_number: '',
        tel: '',
        fax: '',
        delegate_name: '',
        charge_name: '',
        charge_name_kana: '',
        department: '',
        job_title: '',
        email: '',
        contract_flag: '',
        billing_flag: '',
        block_flag: '',
        use_partner_company_approval_default_flag: '',
        billing_target: {
          postal_code: '',
          prefectures_code_id: '',
          city_name: '',
          street_number: '',
          tel: '',
          fax: '',
          charge_name: '',
          charge_name_kana: '',
          department: '',
          job_title: '',
          email: '',
        },
      };
      state.branchId = value;
    }
    this.setState(state);
  }

  /**
   * フォーム生成
   * @param data {object} 会社情報
   */
  initForm(data) {
    let formValues = this.state.formValues;
    _.each(formValues, (value, key) => {
      if (!_.isUndefined(data.company_branch[key])) {
        formValues[key] = _.defaultTo(data.company_branch[key], '');
      }
    });
    formValues.billing_target_id = data.company_branch.billing_target_id;
    if (data.billing_target) {
      _.each(formValues.billing_target, (value, key) => {
        if (data.billing_target[key]) {
          formValues.billing_target[key] = data.billing_target[key];
        }
      });
    } else {
      _.each(formValues.billing_target, (value, key) => {
        formValues.billing_target[key] = '';
      });
    }

    this.setState({ formValues });
  }

  render() {
    const id = this.state.branchId ? this.state.branchId : '';
    const safetyDocItemFlag = this.state.use_greenfile_flg === 1;
    return (
      <div id='slide-view' className='contruction-slide-view show'>
        <Helmet>
          <title>{HEADER_CONSTANTS.title} - 会社情報</title>
        </Helmet>
        <div className='contruction-slide-view__view'>
          <MasterPageHeader
            title={'会社情報'}
            onClose={() => _masterSlideLoader.close()}
          />
          <div className='contruction-slide-view__body contruction-slide-view__body--height-fix'>
            <div className='contruction-detail-view'>
              <div className='contruction-detail-view__sidemenu'>
                <PrimaryCompanyNaviList
                  isSelectedBranchOfficeInformation={true}
                  expirationCompany={this.state.expirationCompany}
                />
              </div>
              <div className='contruction-detail-view__body contruction-detail-view__body--fixed'>
                <div className='contruction-detail-view__menu-dropdown'>
                  <span className='construction-detail-view__button'>
                    <button
                      className='btn'
                      disabled={id ? false : true}
                      onClick={() =>
                        _masterSlideLoader.show('PrimeBranchEdit', {
                          state: { id },
                        })
                      }
                    >
                      編集
                    </button>
                  </span>
                  <span className='construction-detail-view__button'>
                    <div className='construction-detail-view__header-dropdown set-width-dropdown'>
                      <BranchListDropdown
                        value={this.state.branchId}
                        branchName={this.state.formValues.name}
                        readOnly={this.state.roleId == USER_ROLES.branch.id}
                        set={this.setBranch}
                      />
                      <div
                        className='construction-detail-view__dropdown-text'
                        style={
                          this.state.roleId == USER_ROLES.branch.id
                            ? { display: 'none' }
                            : { display: 'block' }
                        }
                      >
                        <p className='construction-detail-view__header-label'>
                          支店を選択
                        </p>
                        <p className='label'>※支店ごとに情報が違います</p>
                      </div>
                    </div>
                  </span>
                </div>
                <div className='contruction-detail-view__bar' />
                <CompanyBranchForm
                  values={this.state.formValues}
                  events={{}}
                  messages={{}}
                  readOnly={true}
                  safetyDocItemFlag={safetyDocItemFlag}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/PrimeBranchPreview.jsx